<template>
    <div class="quickscan-step1">
        <h1>Aanvraag quickscan</h1>
        <quickscan-stepper :current-step="1" :loading="!loaded">
            <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>
            <p>
                Via een aantal korte vragen willen we een eerste toetsing doen of u mogelijk in aanmerking komt om een
                aanvraag in te kunnen dienen.
            </p>
            <p>
                Doorloop 3 eenvoudige stappen en u hoort van ons of u in aanmerking komt.
            </p>

            <v-form @submit.prevent="submit">
              <h3>Contactgegevens aanvrager</h3>
              <v-text-field v-model="applicant.initials" :error="hasErrors('initials')"
                            :error-messages="handleErrors('initials')"
                            label="Voorletters"
                            required></v-text-field>
              <v-text-field v-model="applicant.lastname" :error="hasErrors('lastName')"
                            :error-messages="handleErrors('lastName')" label="Achternaam" required></v-text-field>
              <v-text-field v-model="applicant.tussenvoegsel" :error="hasErrors('tussenvoegsel')"
                            :error-messages="handleErrors('tussenvoegsel')" label="Tussenvoegsel" ></v-text-field>
              <v-radio-group :error="hasErrors('gender')" :error-messages="handleErrors('gender')" label="Geslacht"
                             v-model="applicant.gender" row>
                <v-radio key="male" label="man" value="male"></v-radio>
                <v-radio key="female" label="vrouw" value="female"></v-radio>
                <v-radio key="other" label="gender neutraal" value="other"></v-radio>
              </v-radio-group>
              <v-text-field v-model="applicant.phone" :error="hasErrors('phone')"
                            :error-messages="handleErrors('phone')" label="Telefoonnummer" required></v-text-field>
              <v-text-field v-model="applicant.email" :error="hasErrors('email')"
                            :error-messages="handleErrors('email')" label="E-mailadres" required></v-text-field>
              <v-birthday-picker v-model="applicant.birthdate" :error="hasErrors('birthdate')"
                                 :error-messages="handleErrors('birthdate')" label="Geboortedatum"></v-birthday-picker>
              <br/>
              <h3>Adresgegevens</h3>
              <v-text-field v-model="applicant.address" :error="hasErrors('address')"
                            :error-messages="handleErrors('address')" label="Adres" required></v-text-field>
              <v-text-field v-model="applicant.zipcode" :error="hasErrors('zipcode')"
                            :error-messages="handleErrors('zipcode')" label="Postcode" required></v-text-field>
              <v-text-field v-model="applicant.city" :error="hasErrors('city')" :error-messages="handleErrors('city')"
                            label="Plaatsnaam" required></v-text-field>
              <br/>

              <h3>Andere contactpersoon</h3>
              <v-switch class="pl-4" v-model="applicant.hasOtherContact"
                        label="Heeft u een hulpverlener of andere contactpersoon?" inset
                        @change="changeHasOtherContact()"></v-switch>

              <br/>
              <h3>Wat wilt u aanvragen (kan later niet meer gewijzigd worden)</h3>
              <v-textarea v-model="application.shortDescription" :error="hasErrors('shortDescription')"
                          :error-messages="handleErrors('shortDescription')" label="Korte omschrijving"
                          required></v-textarea>


              <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitting" :disabled="submitting">Ga naar stap
                            2
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </quickscan-stepper>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import VBirthdayPicker from '@/components/VBirthdayPicker';
import QuickscanStepper from '../components/QuickscanStepper';
import VErrorMessages from '@/components/VErrorMessages';

export default {
    name: 'quickscan-step1',
    components: {
        VBirthdayPicker,
        QuickscanStepper,
        VErrorMessages,
    },
    data: () => ({
        loaded: false,
        submitting: false,

        errorMessages: [],
        applicant: {
            initials: null,
            lastname: null,
            tussenvoegsel: null,
            phone: null,
          gender: null,
            email: null,
            birthdate: null,
            address: null,
            zipcode: null,
            city: null,
            hasOtherContact: false,
        },
        errorDetails: {},
        application: {
            shortDescription: null,
        },
    }),
    computed: {
        ...mapGetters({vuex: 'step1'}),
    },
    created: function () {
        const that = this;
        this.quickscanStep1Load().then(function () {
            const applicant = that.vuex.applicant;
            const application = that.vuex.application;

            that.applicant.initials = applicant.initials;
            that.applicant.lastname = applicant.lastname;
            that.applicant.tussenvoegsel = applicant.tussenvoegsel;
            that.applicant.phone = applicant.phone;
            that.applicant.gender = applicant.gender;
            that.applicant.email = applicant.email;
            that.applicant.birthdate = applicant.birthdate;
            that.applicant.address = applicant.address;
            that.applicant.zipcode = applicant.zipcode;
            that.applicant.city = applicant.city;
            that.applicant.hasOtherContact = applicant.hasOtherContact;
            that.application.shortDescription = application.shortDescription;
            that.loaded = true;
        });
    },
    methods: {
        ...mapActions(['quickscanStep1Load', 'quickscanStep1Submit']),
        hasErrors(name) {
            return '' !== this.handleErrors(name);
        },
        changeHasOtherContact(){
          if(!this.applicant.hasOtherContact){
            //hide tab header....
          }
          //console.log( 'hasOtherContact: ' . this.applicant.hasOtherContact);
        },
        handleErrors(name) {
            if (this.errorDetails[name] !== undefined) {
                let error = '';
                Object.entries(this.errorDetails[name]).forEach(entry => {
                    const [errorType, value] = entry;
                    error += " " + value;
                });
                return error;
            }
            return '';
        },
        getPayload: function () {
            const applicant = this.applicant;
            const application = this.application;

            return {
                data: {
                    applicant: {
                        initials: applicant.initials,
                        lastname: applicant.lastname,
                        tussenvoegsel: applicant.tussenvoegsel,
                        gender: applicant.gender,
                        phone: applicant.phone,
                        email: applicant.email,
                        birthdate: applicant.birthdate,
                        address: applicant.address,
                        zipcode: applicant.zipcode,
                        city: applicant.city,
                        hasOtherContact: applicant.hasOtherContact,
                    },
                    application: {
                        shortDescription: application.shortDescription,
                    },
                },
            };
        },
        submit: function () {
            const that = this;
            that.submitting = true;
            this.errorMessages = [];

            this.quickscanStep1Submit(this.getPayload())
                .then(function() {

                   that.$router.push({name: 'quickscan_step2'});

                })
                .catch(function (error) {
                    const response = error.response;
                    if (response.data !== undefined && response.data.error !== undefined) {
                        that.errorDetails = response.data.error.messages;
                        that.errorMessages = ['Er ontbreken gegevens in deze stap'];
                    } else {
                        that.errorMessages = ['Onbekende fout!'];
                    }
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function () {
                    that.submitting = false;
                });
        },
    },
};
</script>
